import Tools from './tools';

export default class Nav {
  constructor() {
  	// Nav

    this.burgerMenu();
    if (window.innerWidth > 1023) {
        this.scrollEvent();
    }
  }

  burgerMenu() {
    const btn = document.querySelector('.burgerButton');
    if (btn) {
      btn.addEventListener('click', () => {
        btn.classList.toggle('open');
        document.querySelector('.navigation').classList.toggle('open');

        if (btn.classList.contains('open')) {
          btn.querySelector('span').innerText = 'Fermer';
        } else {
          btn.querySelector('span').innerText = 'Menu';
        }
      });
    }
  }

  scrollEvent() {
    const nav = document.querySelector('.navigation');
    if (nav) {
        let lastScrollTop = 0;
        window.addEventListener('scroll', () => {
            if (window.pageYOffset > nav.offsetHeight + 30) {
                nav.classList.add('js-fixed');
                window.setTimeout(() => {
                    nav.classList.add('animated');
                }, 1000);
            } else {
                nav.classList.remove('js-fixed');
                nav.classList.remove('visible');
                nav.classList.remove('animated');
            }

            let st = window.pageYOffset || document.documentElement.scrollTop;
            if (st > lastScrollTop) {
                // downscroll code
                nav.classList.remove('visible');
            } else if (st < lastScrollTop) {
                // upscroll code
                nav.classList.add('visible');
            }
            lastScrollTop = st <= 0 ? 0 : st;
        });
    }
  }
}